import { ESdChangeReason, IActionDefinitionDto } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { ActionPicker } from "../properties-panel/action-picker";
import { ScreenInputList } from "../properties-panel/screen-input-list";

export interface IBluetoothActionsPropertiesState {
  isSubmitButtonLoading: boolean;
}

export interface IBluetoothActionsPropertiesProps {}

class BluetoothActionsProperties extends PureSdComponent<
  IBluetoothActionsPropertiesProps & IWithSDProps & IWithContextProp,
  IBluetoothActionsPropertiesState
> {
  constructor(props: IBluetoothActionsPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      isSubmitButtonLoading: false
    };
  }

  getActions = (): IActionDefinitionDto[] => {
    let actionList: IActionDefinitionDto[] = [];
    actionList = _.cloneDeep(this.props.sd.actionDefinitions);
    return actionList;
  };

  render() {
    const method = this.props.sd.getSelectedBluetoothMethod();
    return (
      <>
        <div>
          <div
            style={{
              fontSize: "11px",
              padding: "5px"
            }}
            className="row kuika_topPanel btn-group-vertical"
          >
            {method && (
              <>
                <ActionPicker />
                <ScreenInputList />
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.UpdateAuth) {
      return true;
    }
    return false;
  };
}

const bluetoothActionsProperties = withContext<IBluetoothActionsPropertiesProps>(
  withSD<IBluetoothActionsPropertiesProps>(BluetoothActionsProperties)
);
export { bluetoothActionsProperties as BluetoothActionsProperties };
